import { ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { formatNumber } from '@app/helpers/webform';
import { KeyValue } from '@app/services/webform.service';
import { add, format, parse } from 'date-fns';

@Component({
  standalone: false,
  selector: 'webform-calc-uvg',
  templateUrl: './uvg.component.html',
  styleUrls: ['./uvg.component.scss'],
})
export class UvgComponent implements OnInit {
  @Input() result!: KeyValue;
  @Input() formId!: string;
  @Input() formData!: KeyValue;
  formatNumber: Function = formatNumber;

  readonly #cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    setTimeout(() => {
      this.#cdr.detectChanges();
    }, 300);
  }

  get tomorrow(): string {
    const date = add(new Date(), {
      days: 1,
    });
    return format(date, 'dd.MM.yyyy');
  }
  get contractStart(): string {
    const date = this.formData[`${this.formId}--ins_start_date`];
    if (date) return date;
    return '';
  }

  public get contractEnd(): string {
    let start: any =
      this.formData[`${this.formId}--ins_start`] === 'tomorrow'
        ? this.tomorrow
        : this.contractStart;
    if (!start) return '';
    start = parse(start, 'dd.MM.yyyy', new Date());

    const first = parse(`01.01.${start.getFullYear()}`, 'dd.MM.yyyy', new Date());
    const last = parse(`31.12.${start.getFullYear()}`, 'dd.MM.yyyy', new Date());

    if (format(start, 'dd.MM.yyyy') === format(first, 'dd.MM.yyyy')) {
      return format(add(last, { years: 2 }), 'dd.MM.yyyy');
    } else {
      return format(add(last, { years: 3 }), 'dd.MM.yyyy');
    }
  }
}
